/* POSH — زر الدولة في الناف بار متوقف بقرار العميل.
   المتجر مفتوح لكل دول الخليج، وشوبيفاي بيحدد الدولة تلقائيًا من مكان الزائر. */
(function () {
  'use strict';
  function clean() {
    document.querySelectorAll('[data-posh-chip]').forEach(function (el) { el.remove(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clean);
  else clean();
  document.addEventListener('shopify:section:load', clean);
})();